import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { projectList } from "constants/project";

export const addProject = async (bodyData) => {
  try {
    const res = await API.add_project(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getProjectList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.project_list(pageNum, filters);
    dispatch({ type: projectList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: projectList,
      payload: error?.response?.data || error,
    });
  }
};

export const getProjectById = async (id) => {
  try {
    const res = await API.get_project_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateProjectById = async (id, bodyData) => {
  try {
    const res = await API.edit_project(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteProjectById = async (id) => {
  try {
    const res = await API.delete_project_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}

export const importProject = async (fileData) => {
  try {
    const res = await API.import_project(fileData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const exportProjectData = async (filtersJSON) => {
  try {
    const res = await API.project_csv_export(filtersJSON); // correct call
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};